export default __webpack_public_path__ + "static/media/quickbooks.cc246289.svg";